import { useStore } from "@/store";
import { ScoutCommentStorageKey } from "@/components/Pages/Scout/Messages/ScoutMessageLargePanel/types";

export const getScoutCommentStorageKey = () => {
  const store = useStore();
  if (store.getters["domains/user/isScoutAgentMenuActive"]) {
    return ScoutCommentStorageKey.Agent;
  }

  return ScoutCommentStorageKey.Standard;
};
